import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function WomenIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M27.8822 1H21.0227V4.74152H24.6133L18.7865 10.5683C13.7206 6.96327 6.69143 8.14753 3.08638 13.2135C-0.518679 18.2793 0.665647 25.3087 5.73158 28.9137C10.7975 32.5187 17.8267 31.3343 21.4318 26.2685C24.2123 22.361 24.2123 17.121 21.4318 13.2135L27.2585 7.38678V10.9774H31V4.11792C31 2.39596 29.6042 1 27.8822 1ZM12.2926 27.1905C8.15981 27.1905 4.80961 23.8402 4.80961 19.7075C4.80961 15.5748 8.15986 12.2245 12.2926 12.2245C16.4253 12.2245 19.7755 15.5748 19.7755 19.7075C19.7715 23.8385 16.4236 27.1863 12.2926 27.1905Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
